module.exports = __webpack_public_path__ + "img/logo.8913a28c.png";